import { CondenserProductType } from 'data/types';

export const PTAC_UNIT_SWAP_TOOLTIP = 'Change Unit Size';
export const PTAC_UNIT_SWAP_EMPTY_MESSAGE = 'No other sizes fit this room.';

export function otherPtacUnitSizes(
  alternatives: CondenserProductType[],
  currentProductId: number
): CondenserProductType[] {
  return alternatives.filter(
    (product) => product.productId !== currentProductId
  );
}
